import React from "react";
import { dispatch } from "@rematch/core";
import _ from "lodash";
import { Form } from "formsy-semantic-ui-react";
import LoadingComponent from "../../../../common/LoadingComponent";
import { toastr } from 'react-redux-toastr';

import {
  Input,
  Button,
  Header,
  Modal,
  Message,
  Grid,
} from "semantic-ui-react";

class ShowScenarioInputs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isJSONValid: true,
      updatedMetaDataSchema: this.props.metaDataSchema,
      loader: false,
      selectedScenarioInputs: [],
    };
  }

  close = () => {
    this.props.close();
  };

  render() {
    this.state.selectedScenarioInputs = this.props.selectedScenarioInputs;
    return (
      <div>
      <Modal
        open={this.props.open}
        onClose={this.close}
        size="tiny"
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Header
          content={`View Scenario Input `}
        />
        <Modal.Content style={{padding: '0.5rem'}}>
        {this.props.selectedScenarioInputs.length>0?<Grid>
            <Grid.Row style={{paddingTop: '0.5rem', paddingBottom: '0.5rem'}}>
                <Grid.Column width={7}>
                <div className='acc-header'>Field</div>
                </Grid.Column>
                <Grid.Column width={7}>
                <div className='acc-header'>Value</div>
                </Grid.Column>
            </Grid.Row>
            {this.state.selectedScenarioInputs.map((input, index) => (
                <Grid.Row key={index} style={{ marginBottom: '5px', paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>
                <Grid.Column width={7}>
                <Input style={{ width: "200px", 'pointer-events': 'none' }} readOnly placeholder="Name" value={input.name} />
                </Grid.Column>
                <Grid.Column width={7}>
                    <Input
                    style={{ width: "200px", 'pointer-events': 'none' }}
                    placeholder="Value"
                    readOnly
                    value={input.query ? input.query : input.default}
                    />
                </Grid.Column>
                </Grid.Row>
            ))}
        </Grid>:"No scenario input is added to this scenario"}
        </Modal.Content>
        <Modal.Actions>
          <Button
            className="button-cancel"
            id="cancelSchema"
            onClick={this.close}
          >
            Close
          </Button>
        </Modal.Actions>
      </Modal>
      </div>
    );
  }
}

export default ShowScenarioInputs;
